/**
 * Policy for ref-less fast-drive navigation captures.
 *
 * Ref-less agents re-perceive with their own browser_snapshot/run_code observe
 * after navigation, so PlaywrightClient should skip the forced augmented
 * snapshot and warm-snapshot work while this gate is on.
 */
export class NavigationSnapshotGate {
  private reflessSnapshots = false;

  setReflessSnapshots(refless: boolean): void {
    this.reflessSnapshots = refless;
  }

  shouldSkipPostNavigationSnapshot(): boolean {
    return this.reflessSnapshots;
  }

  shouldSkipWarmSnapshot(): boolean {
    return this.reflessSnapshots;
  }
}

export function createNavigationSnapshotGate(): NavigationSnapshotGate {
  return new NavigationSnapshotGate();
}
